import React from 'react';
import { connectHits } from 'react-instantsearch-dom';
import styles from '../Header.module.scss';

// @ts-ignore
const baseURL = window?.hydrateJSON?.baseUrl || 'https://www.coworker.com/';

const CustomHits = connectHits(({ hits }) => (
  <ul className={styles.result_type}>
    {hits.slice(0, 5).map((hit) => (
      <li
        key={hit.objectID}
        className={styles.result}
        onClick={() => {
          window.location.href = baseURL + (hit.profile_page_url || hit.search_page_url);
        }}
      >
        <a href={baseURL + (hit.profile_page_url || hit.search_page_url)}>
          {hit.name}
          {hit.country_name && `, ${hit.country_name}`}
          {
            +hit.total_spaces > 1 && (
              <span>
                (
                <b>{hit.total_spaces}</b>
                {' '}
                spaces)
              </span>
            )
          }
        </a>
      </li>
    ))}
  </ul>
));

export default CustomHits;
